import { ApiService } from '../services/api_service';
import './burgerMenu.css';
import { checkFunktionFuerBereich } from './functions/checkFunktionFuerBereich';
import * as config from '../wips.config.js';
import { ContextService } from '../services/context_service';
import { DataService } from '../services/data_service';
import DialogWrapper2 from '../core/dialog/dialog_wrapper_v2';
import { EditOptionTabs } from '../login/EditOptionTabs';
import { FaktorenFeedback } from './FaktorenFeedback';
import formStyle from '../core/forms/style/WForm.less';
import { getGewerk } from './functions/getGewerk';
import { getLanguageSelect } from '../i18n/getLanguageSelect';
import { getRoutingFromLocationHash, setRoutingToLocationHash } from './functions/locationHash';
import { IDs } from '../helpers/IDs';
import { i18n } from '../i18n/i18n';
import { i18nLang } from '../i18n/i18nLang';
import { Kontakt } from '../main/Kontakt';
import { lazyInject } from '../services/inversify';
import { LoginForm } from '../login/loginForm';
// import './main.css';
// import '../style/main.css';
import { MainContent } from './MainContent';
import { MehrsprachigkeitFaq } from '../admin/bereiche/datenverwaltung/mehrsprachigkeit/MehrsprachigkeitFaq';
import * as Moment from 'moment';
import { Navigation } from '../main/Navigation';
import { OnlineHilfe } from '../core/helpSystem/OnlineHilfe';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { resizeImageB64ToUrl } from '../core/forms/helpers/resizeImage';
import { RoutingIDs } from '../helpers/RoutingIDs';
import Select from 'react-select';
import { SectionStyle } from '../helpers/SectionStyle';
import { slide as Menu } from 'react-burger-menu';
import { StructureService } from '../services/structure_service';
import style from './main.less';
import { TempLog } from './TempLog';
import { TriggerService } from '../core/trigger/trigger_service';
import { UnternehmenAuswahl } from './UnternehmenAuswahl';
import { Versionen } from '../helpers/versionen';
import { Versionshistorie } from '../bereiche/informationen_hilfe/Versionshistorie';
import { WActionButton } from '../core/elements/WActionButton';
import { WArchivIcon } from '../core/elements/WArchivIcon';
import { WHelpIcon } from '../core/elements/WHelpIcon';
import { WSpinner } from '../core/elements/spinner/WSpinner';

interface MainProps extends React.ClassAttributes<any> {
    params?: any;
    miniLogin?: boolean;
}

interface MainState extends React.ClassAttributes<any> {
    hasToken: boolean;
    userName: string;
    hiddenMenu: boolean;
    routing: any;
    structureAvailable: boolean;
    showSpecial: string;
    data: any;
    lang: string;
    registrierung: Array<any>;
    berater_zuordnung: Array<any>;
    unternehmen: Array<any>;
    konfiguration: Array<any>;
    unternehmenMerge: Array<any>;
    unternehmensdaten: Array<any>;
    unternehmenSel: any;
    userLogin: Array<any>;
    showDlgKontakt: boolean;
    showDlgSelUnternehmen: boolean;
    showEditUser: boolean;
    showFaktoren: boolean;
    showFaq: boolean;
    showLanguages: boolean;
    showVersionshistorie: boolean;
    berater: Array<any>;
    renderExternTab: boolean;
    renderLogDlg: boolean;
    activeUntil?: number;
    locationHash?: string;
    modulSelected: string;
    loadMehrsprachigkeitDone: boolean;
    showSpinner: boolean;
    apiErr: any;
}

export class Main extends React.Component<MainProps, MainState> {

    static autoWalkToNextTool = false;
    static autoWalk: {
        mandantKey: string,
        unternehmen: any,
        index: number,
        length: number
    };

    constructor(props: any) {
        super(props);
        ApiService.module = IDs.MOD_ETOOL;

        // Einbindung Main-Style (hier erstmal anhand instance, später aich brand)
        if(config.instance === 'lux') {
            if(!config.brand || config.brand === 'ka') {
                import('../style/main_lux_ka.css');
            } else
            if(config.brand === 'cc') {
                import('../style/main_lux_cc.css');
            }
        } else {
            import('../style/main.css');
        }

        this.state = {
            hasToken: false,
            hiddenMenu: false,
            routing: {},
            structureAvailable: false,
            userName: '',
            showSpecial: undefined,
            data: {},
            lang: i18nLang.getUILang(),
            registrierung: null,
            unternehmen: null,
            konfiguration: null,
            unternehmenMerge: null,
            unternehmensdaten: null,
            unternehmenSel: null,
            userLogin: null,
            showDlgKontakt: false,
            showDlgSelUnternehmen: false,
            showEditUser: false,
            showFaktoren: false,
            showFaq: false,
            showLanguages: false,
            showVersionshistorie: false,
            berater: null,
            berater_zuordnung: null,
            renderExternTab: false,
            renderLogDlg: false,
            modulSelected: 'classic',
            loadMehrsprachigkeitDone: false,
            showSpinner: false,
            apiErr: null
        };

        this.handleStateChange = this.handleStateChange.bind(this);
        this.initUser = this.initUser.bind(this);
        this.onStructureReceive = this.onStructureReceive.bind(this);
        this.prepareSystem = this.prepareSystem.bind(this);
        this.setRouting = this.setRouting.bind(this);
        this.setApiAdminMandantKey = this.setApiAdminMandantKey.bind(this);
        this.loadBerater = this.loadBerater.bind(this);
        this.getUnternehmenData = this.getUnternehmenData.bind(this);
        this.mergeUnternehmenData = this.mergeUnternehmenData.bind(this);
        this.checkForWalk = this.checkForWalk.bind(this);
        this.openModulSelection = this.openModulSelection.bind(this);
        this.closeModulSelection = this.closeModulSelection.bind(this);
        this.setApiErr = this.setApiErr.bind(this);
        this.resizeUnternehmenLogo = this.resizeUnternehmenLogo.bind(this);

        this.triggerService.register('reload', 'main.loadBerater', this.loadBerater);
        this.triggerService.register('reload', IDs.ENT_REGISTRIERUNG, this.getUnternehmenData);
    }

    private devFeatures: boolean = config.devFeatures || false;
    private structCount = 0;
    private structCountExpected = 4;
    private refBtnModulSelection: any;
    private lastModulSelected: string;
    private removeApiErrHandleId: number;

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        const { params } = this.props;
        if (params && params.adminToken) {
            // Hat zunächst nichts zu tun.
        } else {
            const cookie = document.cookie;
            const parts = cookie.split(';');
            let token;
            parts.forEach((p: string) => {
                const arr = p.split('=');
                const name = arr[0].trim();
                const value = arr[1];
                if (name === 'access_token') {
                    token = value;
                }
            });
            if (!token) {
                // Token-Preset durch z.B., checkServer()
                token = this.apiService.getTokenLocalStorage();
                this.apiService.removeTokenLocalStorage();
            }
            if (token && token !== '') {
                this.setState({ hasToken: true });
                this.checkAccessToken(token);
            }
        }

        this.triggerService.register('main_reload', 'getUnternehmenData', this.getUnternehmenData);

        // WKETOOL-113: 182 Browser-Navigation
        this.initLocationHash();

        // WKETOOL-214: API-Error "Snackbar"
        this.apiService.setErrCallback(this.setApiErr);
    }

    componentDidUpdate(prevProps: any, prevState: any): void {
        // console.log(prevState, this.state);
        if (this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) {
            if (prevState.userName !== this.state.userName) {
                // User-Wechsel: Unternehmen und unternehmensdaten (neu) laden
                this.getUnternehmenData();
            }
            if (this.state.unternehmenSel &&
                (!prevState.unternehmenSel || prevState.unternehmenSel.mandant_key !== this.state.unternehmenSel.mandant_key)) {
                // Auswahl Unternehmen hat sich geändert.
                this.setApiAdminMandantKey();
                this.loadBerater();
            }
            if (!prevState.unternehmenMerge && this.state.unternehmen && this.state.registrierung && this.state.unternehmensdaten && this.state.konfiguration && this.state.userLogin &&
                (!prevState.unternehmen || !prevState.registrierung || !prevState.unternehmensdaten || !prevState.konfiguration || !prevState.userLogin)) {
                this.mergeUnternehmenData();
            }
            if (this.apiService.isAdmin()) {
                // Direkt-Link in das E-Tool.
                if (Array.isArray(this.state.unternehmenMerge) && !this.state.unternehmenSel) {
                    if (this.props.params && this.props.params.mandantKey) {
                        this.presetUnternehmen(this.props.params.mandantKey);
                    }
                }
            }
        } else {
            if (prevState.userName !== this.state.userName) {
                // User geändert.
                this.loadBerater();
            }
        }

        // WKETOOL-175: Der neue Nutzer startet auf der Menübaum-Seite und wählt dort das gewünschte Modul.
        this.autoShowModulSelection();

        // WKETOOL-206: Mehrsprachigkeit
        if (config.devFeaturesMap.N207_MEHRSPRACHIGKEIT && this.state.userName && !this.state.loadMehrsprachigkeitDone) {
            this.setState({ loadMehrsprachigkeitDone: true });
            this.loadMehrsprachigkeit();
        }
    }

    loadMehrsprachigkeit() {
        this.dataService.loadData(IDs.ENT_MEHRSPRACHIGKEIT, {}, {}, (res: any) => {
            i18nLang.rows = res[IDs.ENT_MEHRSPRACHIGKEIT];
            i18nLang.init();
            i18nLang.cbUpdateUI = () => {
                const lang = this.state.lang;
                this.setState({ lang: '' }, () => this.setState({ lang }));
            };
        }, IDs.MOD_ETOOL_ADMIN);
    }

    initLocationHash() {
        this.addEventListenerOnHashchange();
        setTimeout(() => this.setRouting({ path: RoutingIDs.ROUTE_DATENEINGABE }), 3000);
        // setTimeout(() => this.setRouting({ path: RoutingIDs.ROUTE_ENERGIE_COCKPIT }), 3000);
    }

    addEventListenerOnHashchange() {
        window.addEventListener('hashchange', () => {
            const routing = getRoutingFromLocationHash(window.location.hash, this.contextService);
            if (routing) {
                this.setRouting(routing, true);
            }
        });
    }

    setRouting(routing_orig: any, formLocationHash = false): void {
        if (!routing_orig) {
            return;
        }
        routing_orig = JSON.parse(JSON.stringify(routing_orig));
        const routing: any = {};
        if (routing_orig.hasOwnProperty('path')) {
            routing.path = routing_orig.path;
            if (routing_orig.hasOwnProperty('entities')) {
                routing.entities = routing_orig.entities;
            }
            if (routing_orig.hasOwnProperty('standort')) {
                routing.standort = routing_orig.standort;
            }
            if (routing_orig.hasOwnProperty('jahr')) {
                routing.jahr = routing_orig.jahr;
            }
            if (routing_orig.hasOwnProperty('key')) {
                routing.key = routing_orig.key;
            }
        }
        if (routing && JSON.stringify(routing) !== JSON.stringify(this.state.routing)) {
            if (Object.keys(routing).length > 0) {
                console.log('setRouting', routing);
            }
            this.setState({ routing });
            if (routing.path && !formLocationHash) {
                const id: number = routing.path.selectedMenu;
                if (typeof id === 'number' && Object.keys(routing.path).length > 1) {
                    Navigation.cache[id] = routing;
                }
                setRoutingToLocationHash(routing, this.contextService);
            }
        }
    }

    checkAccessToken(token: string) {
        this.apiService.call('checkAccessToken', { check_token: token, module: IDs.MOD_ETOOL_ADMIN },
            (json: string, suc: boolean) => {
                // console.log(json, suc);
                if (suc && json) {
                    let obj;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(e, json);
                    }
                    if (obj && typeof obj === 'object') {
                        const userName = obj.login || obj.user;
                        this.initUser(userName, token, obj);
                    } else {
                        this.setState({ hasToken: false });
                        document.cookie = 'access_token= ; path=/';
                    }
                } else {
                    this.setState({ hasToken: false });
                    document.cookie = 'access_token= ; path=/';
                }
            });
    }

    presetUnternehmen(mandantKey: string) {
        // Vorbelegung der Unternehmen-Auswahl
        const { unternehmenMerge } = this.state;
        if (mandantKey) {
            const untSel = unternehmenMerge.find((u: any) => u.mandant_key === mandantKey);
            if (untSel) {
                this.contextService.clear();
                this.setState({ unternehmenSel: untSel });
            }
        }
    }

    mergeUnternehmenData() {
        const { unternehmen, registrierung, unternehmensdaten, konfiguration, userLogin } = this.state;
        // console.log(registrierung, unternehmensdaten, konfiguration);
        let data: Array<any> = [];
        if (Array.isArray(unternehmen)) {
            data = unternehmen.map((u: any) => u);
        }
        if (Array.isArray(registrierung)) {
            registrierung.forEach((r: any) => {
                const loginFund = (userLogin || []).find((l: any) => l.name === r.mandant_key);
                const udFund = (unternehmensdaten || []).find((u: any) => u.mandant === r.mandant_key);
                const kfFund = (konfiguration || []).find((k: any) => k.mandant === r.mandant_key);
                data.push({
                    mail: r.mail,
                    bereich_key: r.bereich_key,
                    gewerk_tid: udFund && udFund.gewerk_tid ? udFund.gewerk_tid : null,
                    bezeichnung: r.unternehmen,
                    bezeichnung2: udFund && udFund.name && udFund.name !== r.unternehmen ? udFund.name : '',
                    strasse: udFund && (udFund.strasse || udFund.hausnummer) ? `${udFund.strasse || ''} ${udFund.hausnummer || ''}` : `${r.strasse || ''} ${r.hausnummer || ''}`,
                    ort: udFund && udFund.ort ? udFund.ort : r.ort,
                    plz: udFund && udFund.plz ? udFund.plz : r.plz,
                    mandant_key: r.mandant_key,
                    berater: '',
                    testRegi: kfFund ? kfFund.etool_test : r.test_registrierung,
                    lastLogin: loginFund ? loginFund.datum : null,
                    countLogin: loginFund ? loginFund.anzahl : null,
                    uuid: r.uuid
                });
            });
        }
        data.forEach((d: any) => {
            d.isTest = d.testRegi === 1 ? this.renderTestAddOn() : null;
            const bereichKey = d.bereich_key || '';
            d.bereich_key_orig = d.bereich_key;
            d.bereich_key = bereichKey.charAt(0).toUpperCase() + bereichKey.slice(1);
        });
        data.sort((a: any, b: any) => {
            if (a.bezeichnung > b.bezeichnung) {
                return 1;
            } else if (a.bezeichnung < b.bezeichnung) {
                return -1;
            }
            return 0;
        });
        this.setState({ unternehmenMerge: data });
    }

    getUnternehmenData(): void {
        const apiBereichKey = this.apiService.getBereichKey();
        const apiMultiBereichKey = this.apiService.getMultiBereichKeys();
        const loadData = (bz?: Array<any>) => {
            const filterBerich = this.apiService.userHasMultiTools() ? {} :
                apiBereichKey && apiBereichKey !== 'all' ? { bereich_key: apiBereichKey } : {};
            let filterBerichExp: any;
            if (Array.isArray(apiMultiBereichKey) && apiMultiBereichKey.length > 0) {
                filterBerichExp = apiMultiBereichKey.indexOf('all') === -1 ?
                    // { field: 'bereich_key', op: 'IN', val: "('" + apiMultiBereichKey.join("', '") + "')" }
                    { field: 'bereich_key', op: 'IN', val: apiMultiBereichKey }
                    : undefined;
            } else {
                filterBerichExp = this.apiService.userHasMultiTools() ?
                    undefined
                    : apiBereichKey && apiBereichKey !== 'all' ?
                        // { field: 'bereich_key', op: '=', val: "'" + apiBereichKey + "'" }
                        { field: 'bereich_key', op: '=', val: apiBereichKey }
                        : undefined;
            }

            // ENT_UNTERNEHMEN
            this.dataService.loadData(IDs.ENT_UNTERNEHMEN,
                { ...filterBerich }, { fieldList: 'tid, bezeichnung, strasse, ort, plz, mandant_key' },
                (res: any) => {
                    if (res && Array.isArray(res[IDs.ENT_UNTERNEHMEN])) {
                        const unternehmen = bz ?
                            res[IDs.ENT_UNTERNEHMEN].filter((u: any) => bz.some((z: any) => z.unternehmen === u.tid))
                            : res[IDs.ENT_UNTERNEHMEN];
                        this.setState({ unternehmen });
                    }
                }, IDs.MOD_ETOOL_ADMIN);

            // ENT_REGISTRIERUNG
            const filterRegiTidExp = bz ? { field: 'tid', op: 'IN', val: bz.map((r) => r.registrierung) } : undefined;
            this.dataService.loadData(IDs.ENT_REGISTRIERUNG,
                // [{ field: 'kontakt', op: 'IS', val: 'NULL || kontakt = 0' }, { field: 'active', op: '=', val: "'1'" }, ...(filterBerichExp ? [filterBerichExp] : [])],
                [
                    { field: 'active', op: '=', val: 1 },
                    ...(filterRegiTidExp ? [filterRegiTidExp] : []),
                    ...(filterBerichExp ? [filterBerichExp] : [])
                ],
                { keepMandantKey: 1, fieldList: 'tid, unternehmen, strasse, hausnummer, ort, plz, kontakt, test_registrierung, mandant_key, mail, bereich_key, uuid' },
                (res: any) => {
                    // console.log(res, JSON.stringify(res).length);
                    if (res && Array.isArray(res[IDs.ENT_REGISTRIERUNG])) {
                        let registrierung = bz ?
                            res[IDs.ENT_REGISTRIERUNG].filter((r: any) => bz.some((z: any) => z.registrierung === r.tid))
                            : res[IDs.ENT_REGISTRIERUNG];
                        registrierung = registrierung.filter((r: any) => !r.kontakt);
                        this.setState({ registrierung });

                        const mandantKeys: Array<string> = registrierung.map((r: any) => r.mandant_key);
                        // const filterMandantExp = bz ? { field: 'mandant', op: 'IN', val: "('" + (mandantKeys || []).join("', '") + "')" } : undefined;
                        const filterMandantExp = bz ? { field: 'mandant', op: 'IN', val: mandantKeys } : undefined;

                        // ENT_UNTERNEHMENSDATEN (Kultur / Handwerk)
                        this.dataService.loadData(IDs.ENT_UNTERNEHMENSDATEN,
                            [...(filterBerichExp ? [filterBerichExp] : []), ...(filterMandantExp ? [filterMandantExp] : [])],
                            { keepMandantKey: 1, fieldList: 'tid, name, strasse, hausnummer, ort, plz, datei_logo, mandant, bereich_key, gewerk_tid' },
                            (res: any) => {
                                this.dataService.loadData(IDs.ENT_UNTERNEHMENSDATEN,
                                    [...(filterBerichExp ? [filterBerichExp] : []), ...(filterMandantExp ? [filterMandantExp] : [])],
                                    { keepMandantKey: 1, fieldList: 'tid, name, strasse, hausnummer, ort, plz, datei_logo, mandant, bereich_key, gewerk_tid' },
                                    (res2: any) => {
                                        const rows: Array<any> = [...(res[IDs.ENT_UNTERNEHMENSDATEN] || []), ...(res2[IDs.ENT_UNTERNEHMENSDATEN] || [])];
                                        this.setState({ unternehmensdaten: rows });
                                    }, IDs.MOD_ETOOL, null, 'kultur');
                            }, IDs.MOD_ETOOL, null, 'handwerk');

                        // ENT_KONFIGURATION (Kultur / Handwerk)
                        this.dataService.loadData(IDs.ENT_KONFIGURATION,
                            [...(filterMandantExp ? [filterMandantExp] : [])],
                            { keepMandantKey: 1, fieldList: 'etool_test, mandant' },
                            (res: any) => {
                                this.dataService.loadData(IDs.ENT_KONFIGURATION,
                                    [...(filterMandantExp ? [filterMandantExp] : [])],
                                    { keepMandantKey: 1, fieldList: 'etool_test, mandant' },
                                    (res2: any) => {
                                        const rows: Array<any> = [...(res[IDs.ENT_KONFIGURATION] || []), ...(res2[IDs.ENT_KONFIGURATION] || [])];
                                        this.setState({ konfiguration: rows });
                                    }, IDs.MOD_ETOOL, null, 'kultur');
                            }, IDs.MOD_ETOOL, null, 'handwerk');
                    }
                }, IDs.MOD_ETOOL_ADMIN);

            // ENT_USER_LOGIN
            this.dataService.loadData(IDs.ENT_USER_LOGIN,
                {}, { fieldList: 'name, datum, anzahl' },
                (res: any) => {
                    if (res && Array.isArray(res[IDs.ENT_USER_LOGIN])) {
                        this.setState({ userLogin: res[IDs.ENT_USER_LOGIN].sort((a: any, b: any) => a.datum < b.datum ? 1 : -1) });
                    }
                }, IDs.MOD_ETOOL_ADMIN);
        };

        if (this.apiService.isBerater()) {
            const berater = this.apiService.getUserTid();
            this.dataService.loadData(IDs.ENT_BERATERZUORDNUNG,
                { berater }, { fieldList: 'unternehmen, registrierung' },
                (res: any) => {
                    if (res && Array.isArray(res[IDs.ENT_BERATERZUORDNUNG])) {
                        this.setState({ berater_zuordnung: res[IDs.ENT_BERATERZUORDNUNG] });
                        loadData(res[IDs.ENT_BERATERZUORDNUNG]);
                    }
                }, IDs.MOD_ETOOL_ADMIN);
        } else if (this.apiService.userHasMultiTools()) {
            const loginData = this.apiService.getUserLoginData();
            const bz: Array<any> = [];
            if (Array.isArray(loginData.as_mandanten_user_of) && loginData.as_mandanten_user_of.length > 0) {
                loginData.as_mandanten_user_of.forEach((regiTid: number) => bz.push({ registrierung: regiTid }));
            }
            this.dataService.loadData(IDs.ENT_REGISTRIERUNG,
                { mail: loginData.mail }, { fieldList: 'tid' },
                (res: any) => {
                    if (res && Array.isArray(res[IDs.ENT_REGISTRIERUNG])) {
                        res[IDs.ENT_REGISTRIERUNG].forEach((r: any) => bz.push({ registrierung: r.tid }));
                        loadData(bz);
                    }
                }, IDs.MOD_ETOOL_ADMIN);
        } else {
            loadData();
        }
    }

    handleStateChange(state: any): void {
        this.setState({ hiddenMenu: state.isOpen });
    }

    initUser(userName: string, token: string, userObj: any): void {
        // console.log(userName, token, userObj);
        const { uid, unternehmen, mail, is_admin, is_berater, bereich_key, all_bereich_keys, datum_active_until } = userObj;

        this.apiService.setUsername(userName);
        this.apiService.setBereichKey(bereich_key);
        this.apiService.setMultiBereichKeys(all_bereich_keys);
        this.apiService.setUserLoginData(userObj);

        const date = new Date();
        date.setTime(date.getTime() + (1 * 24 * 3600 * 1000));

        if (token && token !== '') {
            this.apiService.setToken(token);
            this.setState({ hasToken: true });
            // Dauerhaft Cookie-Gültigkeit, um zu testen
            if (userName === 'yang.wang@wips-home.de' /* zum Test */) {
                document.cookie = 'access_token=' + token + '; expires=' + date.toUTCString() + '; path=/';
            }
        }

        if (uid && +uid > 0) {
            this.apiService.setUserTid(uid);
        }

        if (is_admin && +is_admin === 1) {
            document.cookie = 'access_token=' + token + '; expires=' + date.toUTCString() + '; path=/';
            this.apiService.setAdminFlag(true);
        } else {
            this.apiService.setAdminFlag(false);
        }

        this.apiService.setBeraterFlag(+is_berater === 1);

        if (unternehmen && mail) {
            this.apiService.setUnternehmenInternal({ bezeichnung: unternehmen, mail });
        }

        this.setState({ userName, activeUntil: datum_active_until });
        OnlineHilfe.tabIdx = 0;
        SectionStyle.curSectionId = 0;
        this.prepareSystem();
        // console.log(document.cookie);
    }

    loadBerater(): void {
        this.setState({ berater: null }, () => {
            const param: any = {};
            if (this.apiService.isAdmin() && this.state.unternehmenSel) {
                param.mandant_key = this.state.unternehmenSel.mandant_key;
            }
            this.apiService.call('getBerater', param, (json: string, succ: boolean) => {
                // console.log(json, succ);
                if (succ && json) {
                    let obj;
                    try {
                        obj = JSON.parse(json);
                    } catch (e) {
                        console.error(e, json);
                    }
                    if (Array.isArray(obj)) {
                        // Zugeordnete Berater vom User in Data setzen
                        const data = this.state.data;
                        data.RES_MAIN_LOAD_BERATER = obj;
                        this.setState({ berater: obj, data });
                    }
                }
            }, IDs.MOD_ETOOL_ADMIN);
        });
    }

    onStructureReceive(data: ReadonlyArray<any>): void {
        // console.log(data);
        // Wir machen nichts, wir wissen nun nur, dass die Daten im Service vorliegen
        // Falls der Call nicht klappt, müssen wir noch was zum Retry bauen.
        this.structCount++;

        if (this.structCount === this.structCountExpected) {
            const structureAvailable = true;
            this.setState({ structureAvailable });
        }
    }

    prepareSystem(): void {
        this.structureService.getStructure('core', this.onStructureReceive, false);
        this.structureService.getStructure('legacy', this.onStructureReceive, false);
        this.structureService.getStructure(IDs.MOD_ETOOL, this.onStructureReceive, false);
        this.structureService.getStructure(IDs.MOD_ETOOL_ADMIN, this.onStructureReceive, false);
        // this.rechteService.loadRechte(() => this.setState({ rechteAvailable: true }));
    }

    render(): JSX.Element {
        const { miniLogin } = this.props;
        const img = require('../img/logo_breit.png');
        const img2 = require('../img/LogoFinal.png');

        if (this.props.miniLogin && this.state.userName && this.state.renderExternTab) {
            this.setState({ renderExternTab: false }, () => {
                const tab = window.open('index.html', '_blank');
                ReactDOM.render(this.renderMain_OLD(), tab.document.body);
            });
        }

        if (!this.state.hasToken || miniLogin) {
            OnlineHilfe.tabIdx = 1;
            SectionStyle.curSectionId = 1;
            return <LoginForm
                miniLogin={miniLogin}
                img={img}
                img2={img2}
                params={this.props.params}
                data={this.state.data}
                setUserToken={(userName: string, auth: any) => {
                    // console.log(auth);
                    auth = auth || {};
                    this.initUser(userName, auth.access_token, auth);
                    if (miniLogin) {
                        this.setState({ renderExternTab: true });
                    }
                }}
            />;
        }

        if (!this.state.structureAvailable) {
            return <WSpinner />;
        }
        return this.renderMain();
    }

    renderAuswahlUnternehmen(): JSX.Element {
        const { unternehmenSel, unternehmenMerge } = this.state;
        if (Array.isArray(unternehmenMerge)) {
            const options = unternehmenMerge.map((u: any) => {
                return {
                    value: u.mandant_key,
                    label: <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ marginRight: 5 }}>{u.bezeichnung}</div>
                        {(this.apiService.isAdmin() || this.apiService.isBerater()) && <div>{u.isTest}</div>}
                    </div>
                };
            });
            const selected = options.find((o: any) => unternehmenSel && unternehmenSel.mandant_key === o.value);
            return (
                <div style={{ display: 'flex' }}>
                    <div style={{ width: 190 }}>
                        <Select
                            styles={{
                                menu: (provided, state) => ({
                                    ...provided,
                                    width: 250,
                                    left: -30
                                })
                            }}
                            className={formStyle.defaultSelect}
                            options={options}
                            value={selected}
                            placeholder={i18n('keine Auswahl', 'sys')}
                            isSearchable={false}
                            isMulti={false}
                            onChange={(evt: any) => {
                                const fnd = unternehmenMerge.find((u: any) => u.mandant_key === evt.value);
                                if (fnd) {
                                    this.contextService.clear();
                                    const bKey = this.apiService.getBereichKey();
                                    if (fnd.bereich_key_orig !== bKey) {
                                        this.apiService.setBereichKey(fnd.bereich_key_orig);
                                    }
                                    this.setState({ unternehmenSel: fnd });
                                }
                            }}
                        />
                    </div>
                    <div style={{ marginLeft: 5 }}>
                        <WActionButton
                            label={i18n('Suche', 'sys')}
                            tooltip={i18n('Suche', 'sys')}
                            key='suche'
                            action='suche'
                            style='small'
                            onAction={() => this.setState({ showDlgSelUnternehmen: true })}
                        />
                    </div>
                </div>
            );
        }
    }

    renderBerater(): JSX.Element {
        const { berater } = this.state;
        if (Array.isArray(berater) && berater.length > 0) {
            const berNamen = berater.map((b: any) => b.name);
            // console.log(berNamen);
            return (
                <span style={{ fontSize: '0.8em', marginTop: 10 }} title={berNamen.join(', ')}>
                    Ihr(e) Berater:in: {berNamen.splice(0, 2).join(', ')}<br />
                </span>
            );
        }
    }

    renderContent(contentBlocked: boolean): JSX.Element {
        const { unternehmenSel, berater } = this.state;
        if ((this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) && !unternehmenSel) {
            if (Main.autoWalk) {
                return <div>Lade...</div>;
            }
            if (this.props.params && this.props.params.mandantKey) {
                // Direkt Link in das E-Tool.
                return null;
            }
            return (
                <div
                    className='cont-unternehmen'
                    style={{ margin: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 0 }}
                >
                    <div className={style.tableUnternehmenText}>
                        <div style={{ fontWeight: 'bold' }}>
                            {this.apiService.isBerater() && <div>Sie sind als Berater:in eingeloggt!</div>}
                            <div>{i18n('Bitte wählen Sie das gewünschte Unternehmen in der Tabelle aus.', 'sys')}</div>
                        </div>
                        <div style={{ fontStyle: 'italic', fontSize: '0.8em' }}>
                            ({i18n('Nutzen Sie, sofern nötig, die Boxen "Suchbegriff eingeben" um das gewünschte Unternehmen zu finden', 'sys')})
                        </div>
                    </div>
                    <div style={{ width: 800, marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: 0 }}>
                        {this.renderDlgSelUnternehmen(true)}
                    </div>
                </div>
            );
        }
        return (
            <MainContent
                key={`MainContent_${unternehmenSel ? unternehmenSel.mandant_key : 'X'}}`}
                lang={this.state.lang}
                setLanguage={(lang: string) => {
                    this.setState({ lang });
                    i18nLang.setLocales();
                }}
                onRoutingChange={this.setRouting}
                routing={this.state.routing}
                unternehmenSel={unternehmenSel}
                contentBlocked={contentBlocked}
                modulSelected={this.state.modulSelected}
                openModulSelection={() => this.openModulSelection()}
                renderUnternehmenAuswahl={() => this.renderDlgSelUnternehmen(true)}
                onModulSelection={(modul: string) => this.setState({ modulSelected: modul })}
                callbackData={(data: any) => {
                    if (berater) {
                        // Zugeordnete Berater vom User in Data setzen
                        data.RES_MAIN_LOAD_BERATER = berater;
                    }
                    this.setState({ data });
                    if (Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN])) {
                        this.setState({ unternehmensdaten: data[IDs.ENT_UNTERNEHMENSDATEN] });
                    }
                }}
                onProcessKennzahlenImportDone={this.checkForWalk}
            />
        );
    }

    checkForWalk(resumeIdx?: number) {
        if (!Main.autoWalkToNextTool) {
            return;
        }
        console.log('checkForWalk', Main.autoWalk);
        const { unternehmenMerge } = this.state;
        const unternehmenFiltered = unternehmenMerge.filter((u: any) => !u.isTest || u.gewerk_tid === 148);
        if (Array.isArray(unternehmenFiltered) && unternehmenFiltered.length > 0) {
            let untIdx;
            if (resumeIdx > 0) {
                untIdx = resumeIdx;
            } else if (!Main.autoWalk || !Main.autoWalk.mandantKey) {
                untIdx = 0;
            } else {
                const idx = unternehmenFiltered.findIndex((u: any) => u.mandant_key === Main.autoWalk.mandantKey);
                untIdx = idx >= 0 ? idx + 1 : -1;
            }
            if (untIdx >= 0 && unternehmenFiltered[untIdx]) {
                const unt = unternehmenFiltered[untIdx];
                console.log('checkForWalk', 'Next:', unt.bezeichnung);
                Main.autoWalk = {
                    mandantKey: unt.mandant_key,
                    unternehmen: unt,
                    index: untIdx,
                    length: unternehmenFiltered.length
                };
                this.contextService.clear();
                this.triggerService.clear();
                this.apiService.setBereichKey(unt.bereich_key_orig);
                if (this.state.unternehmenSel && unt && this.state.unternehmenSel.mandant_key === unt.mandant_key) {
                    // Im Fall, dass das Unternehmen schon geöffnet und geladen ist.
                    this.setState({ data: {}, unternehmenSel: null }, () => this.setState({ unternehmenSel: unt }));
                } else {
                    this.setState({ data: {}, unternehmenSel: unt });
                }
                // this.setState({ data: {}, unternehmenSel: null },
                //     () => setTimeout(() => this.setState({ unternehmenSel: unt }), 1000));
                localStorage.setItem('checkForWalk', `${untIdx}`);
            } else {
                console.log('checkForWalk', 'Done!');
                alert('Ablaufen der Mandanten fertig!');
                Main.autoWalk = null;
                const currentPage = new URL(window.location.href);
                currentPage.searchParams.set('t', (new Date().getTime()) + '');
                window.location.href = currentPage.href;
                localStorage.removeItem('checkForWalk');
            }
        }
    }

    renderDlgFaq(): JSX.Element {
        return (
            <DialogWrapper2
                title='FAQ'
                onAfterClose={() => this.setState({ showFaq: undefined })}
            >
                <div style={{ width: '90vw', maxWidth: 1350, minHeight: 0, display: 'flex', flex: 1, flexDirection: 'column' }}>
                    <MehrsprachigkeitFaq
                        data={this.state.data}
                        isDialog
                        isPublic
                    />
                </div>
            </DialogWrapper2>
        );
    }

    renderDlgSelUnternehmen(inline = false): JSX.Element {
        const { unternehmenMerge } = this.state;
        let table = <div>{i18n('Lade Unternehmen', 'sys')}...</div>;
        if (Array.isArray(unternehmenMerge)) {
            table = <UnternehmenAuswahl
                registrierungen={this.state.registrierung}
                ber_zuo={this.state.berater_zuordnung}
                unternehmen={unternehmenMerge}
                onSelected={(row: any) => {
                    this.contextService.clear();
                    const bKey = this.apiService.getBereichKey();
                    if (row.bereich_key_orig !== bKey) {
                        this.apiService.setBereichKey(row.bereich_key_orig);
                    }
                    this.setState({ unternehmenSel: row, showDlgSelUnternehmen: false });
                }}
                onListChange={this.mergeUnternehmenData}
            />;
        }
        if (inline) {
            return table;
        }
        return (
            <DialogWrapper2
                containerId='unternehmen'
                onAfterClose={() => this.setState({ showDlgSelUnternehmen: false })}
                left={10}
            >
                <div>{table}</div>
            </DialogWrapper2>
        );
    }

    renderFooter(): JSX.Element {
        const bereich_key: string = (((this.state.data || {})[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).bereich_key_orig || null;
        const email: string = (((this.state.data || {})[IDs.ENT_BRANCHEN_BEREICHE] || [])
            .find((item: any) => item.intern_key === bereich_key) || {}).email || '';
        const emails: string[] = email.toString().trim().split(';').map((item: string) => item.trim());
        const mailto: string = (emails[0] || '').length ? emails.join(';') : 'service@energie-tool.de';
        const showKontakte: boolean = checkFunktionFuerBereich('InformationenHilfe_Kontakte', bereich_key);
        // const enableModulAuswahl = config.devFeaturesMap && config.devFeaturesMap.N139_MODUL_AUSWAHL ? true : false;
        return (
            <div className={style.footer}>
                <div
                    style={{ cursor: 'pointer' }}
                    onClick={this.openModulSelection}
                    ref={(refBtnModulSelection: any) => {
                        if (!this.refBtnModulSelection) {
                            this.refBtnModulSelection = refBtnModulSelection;
                        }
                    }}
                >
                    {i18n('Modul-Auswahl', 'sys')}
                </div>
                <div
                    onClick={() => this.closeModulSelection(() =>
                        this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_SITEMAP })
                    )}
                >
                    {i18n('Sitemap', 'sys')}
                </div>
                {!!(config.devFeaturesMap || {}).N214_FAQ &&
                    <div
                        onClick={() => this.closeModulSelection(() =>
                            (this.state.unternehmensdaten || []).length
                                ? this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_FAQ })
                                : this.setState({ showFaq: true })
                        )}
                    >
                        {i18n('FAQ', 'sys')}
                    </div>
                }
                <div
                    onClick={() => this.closeModulSelection(() =>
                        this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_NUTZUNGSBEDINGUNGEN })
                    )}
                >
                    {i18n('Nutzungsbedingungen/Datenschutz', 'sys')}
                </div>
                <div
                    onClick={() => this.closeModulSelection(() =>
                        this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_IMPRESSUM })
                    )}
                >
                    {i18n('Impressum', 'sys')}
                </div>
                {showKontakte &&
                    <div
                        onClick={() => this.closeModulSelection(() =>
                            this.devFeatures && this.apiService.isAdmin()
                                ? this.setState(
                                    { showDlgKontakt: true }, () => this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_KONTAKTE })
                                )
                                : this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_KONTAKTE })
                        )}
                    >
                        <a
                            style={{ textDecoration: 'none' }}
                            href={(!this.devFeatures || !this.apiService.isAdmin()) ? `mailto:${mailto}` : undefined}
                        >
                            {i18n('Kontakt/Unterstützung', 'sys')}
                        </a>
                    </div>
                }
                {/*<div onClick={() => this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_PARTNER })}>
                    <a style={{ textDecoration: 'none' }} href='mailto: service@energie-tool.de'>Kontakt aufnehmen</a>
                </div>*/}
                <div
                    onClick={() => this.closeModulSelection(() =>
                        this.setRouting({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE_VERSIONSHISTORIE })
                    )}
                >
                    E-Tool {Versionen.VERSION}{this.apiService.isAdmin() ? Versionen.VERSION_REV : ''} &middot;
                    CFM {Versionen.VERSION_CFM} &middot; {i18n('Stand', 'sys')}: {Versionen.STAND}
                </div>
            </div>
        );
    }

    renderMain(): JSX.Element {
        const { activeUntil } = this.state;
        const isRegiBanned = activeUntil > 0 && activeUntil < Moment().unix();
        return (<div className={style.contentWrapper}>
            {this.renderContent(isRegiBanned)}
            {!Main.autoWalk && this.state.data && Object.keys(this.state.data).length > 0 && this.state.data['loadDone'] && this.renderFooter()}
            {this.state.apiErr && this.renderApiErr()}
        </div>);
    }


    renderMain_OLD(): JSX.Element {
        const bereich_key: string = this.apiService.getBereichKey();
        const img = require('../img/LogoKlein.jpg');
        const img2 = bereich_key === 'handwerk'
            ? require('../img/logo_bereich_handwerk.png')
            : (bereich_key === 'kultur' ? require('../img/logo_bereich_kultur.png') : null);
        const img3 = require('../img/LogoMenue.png');
        const { data, unternehmenSel, activeUntil } = this.state;
        let unternehmen: any = {};

        if (data && Array.isArray(data[IDs.ENT_UNTERNEHMENSDATEN]) && data[IDs.ENT_UNTERNEHMENSDATEN].length > 0) {
            unternehmen = data[IDs.ENT_UNTERNEHMENSDATEN][0];
        }
        const gewerk_tid = getGewerk(data);
        const konfiguration: any = ((data || {})[IDs.ENT_KONFIGURATION] || [])[0] || {};
        const modul: string = this.state.modulSelected || null;
        const showEffizienznetzwerk: boolean = konfiguration.anwendungskontext === 'netzwerkarbeitsbuch' && modul !== 'cfm';
        const showZusatztools: boolean = modul !== 'cfm';
        const isRegiBanned = activeUntil > 0 && activeUntil < Moment().unix();
        const isRegiValidUntil = activeUntil > 0 && activeUntil >= Moment().unix();

        return (
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
                {!Main.autoWalk && <div className={style.topWrapper}>
                    <div
                        className={style.logoWrapper}
                        style={{ cursor: 'pointer', display: 'flex', width: 300 }}
                        onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_DATENAUSWERTUNG }, false)}
                    >
                        <img src={img} height={40} alt='LogoKlein' />
                        {img2 &&
                            <img src={img2} height={40} alt='Handwerk' />
                        }
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', overflowX: 'hidden' }}>
                        {unternehmen && unternehmen.name &&
                            this.renderTitel(unternehmen.name)
                        }
                        {isRegiValidUntil && <div style={{ fontSize: '0.7em', fontStyle: 'italic', color: 'gray' }}>
                            {`Dieses E-Tool kann noch bis zum "${Moment.unix(activeUntil).format('DD.MM.YYYY')}" uneingeschränkt verwendet werden.`}
                        </div>}
                    </div>
                    <div style={{ width: 300 }}>
                        <div
                            style={{
                                display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', position: 'absolute',
                                right: 50, marginTop: 5
                            }}
                        >
                            {unternehmen && unternehmen.datei_logo > 0 &&
                                <div style={{ marginTop: 5, marginRight: 3 }}>
                                    <WArchivIcon
                                        archivId={unternehmen.datei_logo}
                                        previewMaxHeight={32}
                                        previewMaxWidth={240}
                                        hideFilename={true}
                                        URLContextKey={'UNTERNEHMEN_LOGO_URL'}
                                        onGetFileContent={this.resizeUnternehmenLogo}
                                    />
                                </div>
                            }
                            {config.devFeaturesMap.N207_MEHRSPRACHIGKEIT && this.state.loadMehrsprachigkeitDone &&
                                <div style={{ textAlign: 'center', zIndex: 100 }}>
                                    {!this.state.showLanguages &&
                                        <WActionButton
                                            label={i18n('Sprache', 'sys')}
                                            tooltip={i18n('Sprache', 'sys')}
                                            key={`lang_${this.state.lang}`}
                                            action={`lang_${this.state.lang}`}
                                            style='big'
                                            styleProps={{ backgroundColor: '#fff', backgroundSize: '35px 35px' }}
                                            onAction={() => this.setState({ showLanguages: true })}
                                        />
                                    }
                                    {this.state.showLanguages &&
                                        getLanguageSelect(this.state.lang, (lang: string) => {
                                            // window.location.reload();
                                            this.setState({ showLanguages: false });
                                            if (this.state.lang !== lang) {
                                                this.setState({ lang });
                                                i18nLang.setLocales();
                                            }
                                        })
                                    }
                                </div>
                            }
                            <WActionButton
                                label='Einstellung'
                                tooltip='Einstellung'
                                key='config'
                                action='config'
                                style='big'
                                styleProps={{ marginRight: 5, marginLeft: 0, backgroundColor: '#fff', backgroundSize: '35px 35px' }}
                                onAction={() => this.setState({ showEditUser: true })}
                            />
                            {unternehmen && unternehmen.tid && <WActionButton
                                label='Startseite'
                                tooltip='Startseite'
                                key='home'
                                action='home'
                                style='big'
                                styleProps={{ marginRight: 5, marginLeft: 0, backgroundColor: '#fff', backgroundSize: '35px 35px' }}
                                onAction={() => this.openModulSelection()}
                            />}
                            {this.devFeatures && this.apiService.isAdmin() && this.state.unternehmenSel &&
                                <WActionButton
                                    label='Feedback / Faktoren'
                                    tooltip='Feedback / Faktoren'
                                    key='content'
                                    action='content'
                                    style='big'
                                    styleProps={{ marginRight: 8, marginLeft: 0, backgroundColor: '#fff', backgroundSize: '35px 35px' }}
                                    onAction={() => this.setState({ showFaktoren: true })}
                                />
                            }
                        </div>
                        <Menu
                            isOpen={this.state.hiddenMenu}
                            onStateChange={(state: any) => this.handleStateChange(state)}
                            right
                            width={300}
                        >
                            <span style={{ width: 0 }} />
                            <img src={img3} width={240} style={{ marginBottom: 20 }} alt='LogoMenue' />
                            <div style={{ display: 'flex', alignItems: 'flex-end', marginBottom: 0 }} className='userName'>
                                <div><small>{'Login: ' + this.state.userName}</small></div>
                            </div>
                            {this.apiService.isMandantenUser() && <span><small>Sie sind Zusatznutzer:in.</small></span>}
                            {this.apiService.isMainUser() && <span><small>Sie sind Hauptnutzer:in.</small></span>}
                            {this.apiService.isAdmin() && <span><small>Sie sind Admin.</small></span>}
                            {this.apiService.isBerater() ? <span><small>Sie sind Berater:in.</small></span> : this.renderBerater()}
                            {(this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) &&
                                <span style={{ marginTop: 10 }}>
                                    <small>Unternehmen:&nbsp;</small>
                                    {this.renderAuswahlUnternehmen()}
                                </span>
                            }
                            <div style={{ height: 30, marginBottom: 10 }}>
                                {this.state.data && this.state.data.reloadData
                                    ?
                                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                                        <div>
                                            <button
                                                style={{
                                                    backgroundColor: '#bccae3', color: 'black', padding: 5, borderRadius: 5, marginTop: 10,
                                                    width: 190
                                                }}
                                                onClick={() => {
                                                    const reloadFunc = this.state.data.reloadData;
                                                    this.setState({ data: {} }, () => reloadFunc());
                                                }}
                                            >
                                                Daten erneut laden
                                            </button>
                                        </div>
                                        <WHelpIcon
                                            data={data}
                                            styleDivProps={{ marginTop: 7 }}
                                            styleProps={{
                                                width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top',
                                                marginTop: 10, marginLeft: 6
                                            }}
                                            label={'Daten erneut laden'}
                                            helpKey={'helpDatenErneutLaden'}
                                            type={'info'}
                                            editBar={true}
                                        />
                                    </div>
                                    :
                                    !((this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) && !unternehmenSel)
                                        ? <WSpinner /> : null
                                }
                            </div>
                            <hr style={{ color: '#ddd', marginTop: 15 }} />
                            <div
                                className='menu-item'
                                onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_DATENEINGABE }, false)}
                                style={{ color: '#bccae3' }}
                            >
                                <p>{i18n('Dateneingabe', 'tab')}</p>
                            </div>
                            <div
                                className='menu-item'
                                onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_DATENAUSWERTUNG }, false)}
                                style={{ color: '#6692c3' }}
                            >
                                <p>{i18n('Datenauswertung', 'tab')}</p>
                            </div>
                            {showEffizienznetzwerk &&
                                <div
                                    className='menu-item'
                                    onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_EFFIZIENZNETZWERK }, false)}
                                    style={{ color: '#0093c6' }}
                                >
                                    <p>{i18n('Effizienznetzwerk', 'tab')}</p>
                                </div>
                            }
                            {showZusatztools &&
                                <div
                                    className='menu-item'
                                    onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_ZUSATZTOOLS }, false)}
                                    style={{ color: '#f79646' }}
                                >
                                    <p>{i18n('Zusatztools', 'tab')}</p>
                                </div>
                            }
                            <div
                                className='menu-item'
                                onClick={() => this.onClickMenuItem({ path: RoutingIDs.ROUTE_INFORMATIONEN_HILFE }, false)}
                                style={{ color: '#616468' }}
                            >
                                <p>{i18n('Info / Hilfe', 'tab')}</p>
                            </div>
                            {this.apiService.isAdmin() && <div
                                className='menu-item'
                                onClick={() => this.setState({ renderLogDlg: true })}
                            >
                                <p>{i18n('Log', 'sys')}</p>
                            </div>}
                            {this.apiService.isAdmin() && <div>
                                <button
                                    style={{
                                        backgroundColor: '#bccae3', color: 'black', padding: 5, borderRadius: 5, marginTop: 10,
                                        width: 190
                                    }}
                                    onClick={() => {
                                        let resumeIdx = +localStorage.getItem("checkForWalk");
                                        if (resumeIdx > 0) {
                                            if (!window.confirm('Der Prozess wurde in der letzten Zeit abgebrochen. Wollen Sie den Prozess fortsetzen?')) {
                                                if (window.confirm('Soll der Prozess von vorne gestartet werden?')) {
                                                    resumeIdx = null;
                                                } else {
                                                    return;
                                                }
                                            }
                                        }
                                        if (window.confirm('Jetzt starten?')) {
                                            this.setState({ hiddenMenu: false }, () => {
                                                Main.autoWalkToNextTool = true;
                                                this.checkForWalk(resumeIdx);
                                            });
                                        }
                                    }}
                                >
                                    {i18n('Mandanten ablaufen', 'sys')}
                                </button>
                            </div>}
                            <div
                                className='menu-item'
                                onClick={() => {
                                    if (window.confirm('Wirklich ausloggen?')) {
                                        document.cookie = 'access_token= ; path=/';
                                        this.apiService.removeTokenLocalStorage();
                                        // location.reload();
                                        const currentPage = new URL(window.location.href);
                                        currentPage.searchParams.set('t', (new Date().getTime()) + '');
                                        window.location.href = currentPage.href;
                                    }
                                }}
                            >
                                <p>{i18n('Ausloggen', 'sys')}</p>
                            </div>
                            <span style={{ fontSize: 9 }}>Stand: {Versionen.STAND}</span>
                        </Menu>
                    </div>
                </div>
                }
                <div className={style.contentWrapper}>
                    {this.renderContent(isRegiBanned)}
                </div>
                {!Main.autoWalk && this.renderFooter()}
                {this.state.showSpecial &&
                    <div>
                        <DialogWrapper2
                            onAfterClose={() => this.setState({ showSpecial: undefined })}
                        >
                            {this.state.showSpecial}
                        </DialogWrapper2>
                    </div>
                }
                {this.state.showDlgKontakt &&
                    <div><Kontakt onClose={() => this.setState({ showDlgKontakt: false })} /></div>
                }
                {this.state.showVersionshistorie &&
                    <DialogWrapper2
                        onAfterClose={() => this.setState({ showVersionshistorie: false })}
                        title='Versionshistorie'
                        left={10}
                    >
                        <div
                            style={{
                                minWidth: 800, maxWidth: 'calc(50vw - 40px)', padding: 10, paddingTop: 0, paddingRight: 0,
                                boxSizing: 'border-box'
                            }}
                        >
                            <Versionshistorie
                                data={this.state.data}
                                onClose={() => this.setState({ showVersionshistorie: false })}
                                openFirstItem
                            />
                        </div>
                    </DialogWrapper2>
                }
                {this.state.showDlgSelUnternehmen && this.renderDlgSelUnternehmen()}
                {this.state.showFaq && this.renderDlgFaq()}
                {this.state.showFaktoren &&
                    <DialogWrapper2
                        onAfterClose={() => this.setState({ showFaktoren: false })}
                        title='Feedback / Faktoren'
                    >
                        <div style={{ minWidth: 800, maxWidth: 'calc(100vw - 40px)' }}>
                            <FaktorenFeedback data={this.state.data} />
                        </div>
                    </DialogWrapper2>
                }
                {this.state.showEditUser &&
                    <div>
                        <DialogWrapper2
                            onAfterClose={() => this.setState({ showEditUser: undefined })}
                        >
                            <EditOptionTabs
                                data={this.state.data}
                                onRoutingChange={this.setRouting}
                                initialTab={0}
                                onClose={() => this.setState({ showEditUser: undefined })}
                            />
                        </DialogWrapper2>
                    </div>
                }
                {this.state.renderLogDlg && <DialogWrapper2
                    onAfterClose={() => this.setState({ renderLogDlg: false })}
                >
                    <div style={{ width: 800, padding: 20, fontSize: 12 }}>
                        <TempLog />
                    </div>
                </DialogWrapper2>}
                {this.state.showSpinner && <WSpinner />}
                {this.state.apiErr && this.renderApiErr()}
            </div>
        );
    }

    renderTitel(name: string): JSX.Element {
        const regi = this.state.data[IDs.ENT_REGISTRIERUNG];
        const etool_test = regi && regi.length > 0 && regi[0].test_registrierung === 1;
        const addOn = (etool_test && (this.apiService.isAdmin() || this.apiService.isBerater()))
            ? this.renderTestAddOn('Testumgebung') : null;
        return (
            <div className={style.mainTitel}>
                <div style={{ marginTop: 15, whiteSpace: 'nowrap' }}>E-Tool {name} &nbsp; &nbsp; {addOn}</div>
            </div>
        );
    }

    renderTestAddOn(text = 'Test'): JSX.Element {
        return <div
            style={{
                display: 'inline', backgroundColor: 'lightgray', color: 'black', fontSize: 10, padding: 3, verticalAlign: 'middle',
                height: 20
            }}
        >
            {text}
        </div>;
    }

    setApiAdminMandantKey(): void {
        const { unternehmenSel } = this.state;
        if ((this.apiService.isAdmin() || this.apiService.isBerater() || this.apiService.userHasMultiTools()) && unternehmenSel) {
            this.apiService.setMandantKey(unternehmenSel.mandant_key);
            this.apiService.setBereichKey(unternehmenSel.bereich_key_orig);
        } else {
            this.apiService.setMandantKey(null);
        }
    }

    onClickMenuItem(routing: any, hiddenMenu: boolean) {
        this.setRouting(routing);
        this.setState({ hiddenMenu });
    }

    autoShowModulSelection() {
        if (this.refBtnModulSelection && this.state.data) {
            const data = this.state.data;
            if (Array.isArray(data[IDs.ENT_KONFIGURATION]) && data[IDs.ENT_KONFIGURATION].length > 0
                && Array.isArray(data[IDs.ENT_REGISTRIERUNG]) && data[IDs.ENT_REGISTRIERUNG].length > 0) {
                const konfig = data[IDs.ENT_KONFIGURATION][0];
                const regist = data[IDs.ENT_REGISTRIERUNG][0];
                const isNeueRegi = regist.datum_bearbeitung > 1744600000 /* Ab heute 14. April 2025 */;
                if (!this.lastModulSelected && !konfig.dateneingabe_variante && isNeueRegi) {
                    this.openModulSelection();
                }
            }
        }
    }

    openModulSelection() {
        this.setRouting({ path: RoutingIDs.ROUTE_DATENEINGABE })
        if (this.state.modulSelected !== 'selection') {
            this.lastModulSelected = this.state.modulSelected;
        }
        this.setState({ modulSelected: 'selection' });
    }

    closeModulSelection(callback?: () => void) {
        if (this.lastModulSelected) {
            this.setState({ modulSelected: this.lastModulSelected }, callback);
        } else {
            if (typeof callback === 'function') {
                callback();
            }
        }
    }

    setApiErr(apiErr: any) {
        this.setState({ apiErr });
        clearTimeout(this.removeApiErrHandleId);
        this.removeApiErrHandleId = window.setTimeout(() => {
            this.setState({ apiErr: undefined });
            this.removeApiErrHandleId = undefined;
        }, 5000);
    }

    renderApiErr(): JSX.Element {
        return <div
            className={style.apiErr}
        >
            Eine Anfrage an den Server ist fehlgeschlagen!
        </div>;
    }

    resizeUnternehmenLogo(blob: any, url: string, base64: string): void {
        const jobs = [
            // { contextKey: 'UNTERNEHMEN_LOGO_RESIZE_100_URL', maxWidth: 100, maxHeight: 100 },
            { contextKey: 'UNTERNEHMEN_LOGO_RESIZE_200_URL', maxWidth: 200, maxHeight: 200 }
        ];
        jobs.forEach((j: any) =>
            resizeImageB64ToUrl(base64, 'image/jpeg', (url: string) => {
                this.contextService.set(j.contextKey, url);
            }, j.maxWidth, j.maxHeight)
        );
    }
}
